import React from 'react'
import { Button } from 'antd'
import type { Organization, OrgTabId } from '../types'
import { orgTabLabel } from '../utils'
import NewOrganization, { type NewOrganizationResult } from './NewOrganization'

interface OrgTabsProps {
  adminOrgs: Organization[]
  activeTab: OrgTabId
  orgCount: number
  canCreateOrganization: boolean
  sourcePlan?: string
  onTabChange: (tab: OrgTabId) => void
  onOrganizationCreated: (result: NewOrganizationResult) => void
}

const OrgTabs: React.FC<OrgTabsProps> = ({
  adminOrgs,
  activeTab,
  orgCount,
  canCreateOrganization,
  sourcePlan,
  onTabChange,
  onOrganizationCreated,
}) => (
  <div className="um-refactor__org-tabs">
    <div className="um-refactor__org-tabs-pills">
      {adminOrgs.length > 1 && (
        <Button
          type="text"
          className={`um-refactor__pill${activeTab === 'all' ? ' um-refactor__pill--active' : ''}`}
          onClick={() => onTabChange('all')}
        >
          All organizations
        </Button>
      )}
      {adminOrgs.map((org) => (
        <Button
          key={org.id}
          type="text"
          className={`um-refactor__pill${activeTab === org.id ? ' um-refactor__pill--active' : ''}`}
          onClick={() => onTabChange(org.id)}
        >
          {orgTabLabel(org)}
        </Button>
      ))}
    </div>
    {canCreateOrganization && (
      <div className="um-refactor__org-tabs-action">
        <NewOrganization
          orgCount={orgCount}
          canCreate={canCreateOrganization}
          sourcePlan={sourcePlan}
          onCreated={onOrganizationCreated}
        />
      </div>
    )}
  </div>
)

export default OrgTabs
